var FilterableResult = require('../General/FilterableResult').FilterableResult;
import { AbconetApi } from '../General/AbconetApi';

export class GroupListing extends React.Component {

    constructor(props) {
        super(props);
        this.filterableResult = React.createRef();
        this.state = {
            markedForDeletion: {},
            isDeleting: {}
        };
    }

    deleteGroup(id) {
        var markedForDeletion = this.state.markedForDeletion;
        markedForDeletion[id] = true;

        this.setState({ markedForDeletion: markedForDeletion });
    }

    removePendingDelete(id) {
        var markedForDeletion = this.state.markedForDeletion;
        markedForDeletion[id] = false;

        this.setState({ markedForDeletion: markedForDeletion });
    }

    confirmDelete(id) {
        var isDeleting = this.state.isDeleting;
        isDeleting[id] = true;

        this.setState({ isDeleting: isDeleting });

        AbconetApi
            .delete('/api/group/' + id + '/delete')
            .then(()=>{
                this.filterableResult.current.updateData();
            });
    }

    renderDeleteHover(row) {
        if (this.state.markedForDeletion[row.id]) {
            var isDeleting = this.state.isDeleting[row.id];
            var buttonClassName = "btn btn-danger";
            if (isDeleting) {
                buttonClassName = "btn btn-danger saving";
            }

            return (
                <div className="delete-confirm">
                    <div className="row">
                        <div className="col-12">
                            <div className="message">Deleting a group will permanently remove it.</div>
                            <div className="btn-group" role="group" aria-label="Basic example">
                                <button type="button" className="btn btn-outline-primary" onClick={this.removePendingDelete.bind(this, row.id)} disabled={isDeleting}>No, Keep Group</button>
                                <button type="button" className={buttonClassName} onClick={this.confirmDelete.bind(this, row.id)} disabled={isDeleting}>Yes, Delete Group</button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }


    renderRows(row) {
        return (
            <div className="item" key={row.id}>
                {this.renderDeleteHover(row)}
                <div className="row">
                    <div className="col-6">
                        <a href={`/groups/${row.id}`}>{row.description}</a>
                    </div>
                    <div className="col-3">
                        <a>{row.groupMemberCount}</a>
                    </div>
                    <div className="col-3 text-center">
                        <span href="#" className="delete-button" onClick={(ev) => this.deleteGroup(row.id)}><i className="icon icon-trash px-3 lead"></i></span>
                    </div>
                </div>
            </div>
        );
    }

    renderData(resultCollection) {
        return (
            <div className="list-group">
                <div className="row header">
                    <div className="col-6 col-hd">
                        Description
                    </div>
                    <div className="col-3 col-hd">
                        Members
                    </div>
                    <div className="col-3">

                    </div>
                </div>

                {resultCollection.map(this.renderRows.bind(this))}
            </div>
        );
    }

    render() {

        return (
            <div>
                <FilterableResult ref={this.filterableResult} {... this.props} renderData={this.renderData.bind(this)} />
            </div>
        );
    }

}